/**
 * Copyright 2024 Phenix Real Time Solutions, Inc. Confidential and Proprietary. All Rights Reserved.
 */
class UserStoreProvider {
  private store = {};
  async get(key: string, defaultValue: string): Promise<string> {
    return this.store[key] || defaultValue;
  }

  async set(key: string, value: string): Promise<void> {
    this.store[key] = value;
  }
}

export default UserStoreProvider;